module.exports = __webpack_public_path__ + "static/media/checkmark-red.6223e784.svg";